import { integrationsDirectCdiSegmentsConfig } from "@dashboardApi/apis/integrationsDirectCdiSegmentsConfig/constants";

import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiSegmentsConfigSegmentsConfigIdCacheKeys: AllRouteEndpoints[] = [
  integrationsDirectCdiSegmentsConfig,
];
